import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { DownTimeTracking } from "./dto/downtime-tracking.entity";
import { DowntimeTrackingDto } from "./dto/downtime-tracking.dto";
import { DownTimeDashboardDateRequest, DowntimePiechartResonseModel, DowntimeTrackingMachineNameResponseModell, DownTimeTrackingResponsemodel } from "@gtpl/shared-models/masters";
import {AllDownTimeTrackingResponseModel} from "@gtpl/shared-models/masters";
import { DownTimeTrackingAdapter } from "./dto/downtime-tracking.adapter";
import { DowntimeMachineNameRequest, DownTimeTrackingPiechartRequest, DownTimeTrackingRequest } from "./dto/downtime-tracking.request";
import { DownTimeTrackingService } from './downtime-tracking.service';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { EmployeeByUnitRequest } from '../employee-details/dto/employee-by-unit-request';


@ApiTags('downtime-tracking')
@Controller('downtimetracking')
 export class DowntimeTrackingController{

    constructor(
       private downtimetrackingService: DownTimeTrackingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
  
      ){}

      @Post('/createDownTimeTracking')
      async createDownTimeTracking(@Body() downtimeTrackingDto:DowntimeTrackingDto,isUpdate:boolean=false): Promise<DownTimeTrackingResponsemodel> {
        try {
            return await this.downtimetrackingService.createDownTimeTracking(downtimeTrackingDto, false);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(DownTimeTrackingResponsemodel, error);
          }
        }

        @Post('/updateDownTimeTracking')
        async updateDownTimeTracking(@Body() downtimetrackingDto: DowntimeTrackingDto,@Req() request:Request): Promise<DownTimeTrackingResponsemodel> {
          try {
            console.log('update downtimetracking');downtimetrackingDto
            console.log(request);
            return await this.downtimetrackingService.createDownTimeTracking(downtimetrackingDto, true);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(DownTimeTrackingResponsemodel, error);
          }
        }
        @Post('/getAllDownTimeTrackings')
        // @UseGuards(AuthGuard('jwt'))
        async getAllDownTimeTrackings(@Body() req:EmployeeByUnitRequest): Promise<AllDownTimeTrackingResponseModel> {
          try {
            return await this.downtimetrackingService.getAllDownTimeTrackings(req);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(AllDownTimeTrackingResponseModel, error);
          }
        }

          
    @Post('/activateOrDeactivateDownTimeTracking')
    async activateOrDeactivateDownTimeTracking(@Body() downtimetrackingreq: DownTimeTrackingRequest): Promise<DownTimeTrackingResponsemodel> {
        try {
            return await this.downtimetrackingService.activateOrDeactivateDownTimeTracking(downtimetrackingreq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(DownTimeTrackingResponsemodel, err);
        }
    }

    @Post('/getAllActiveDownTimeTracking')
    async getAllActiveDownTimeTracking(@Req() request: Request): Promise<AllDownTimeTrackingResponseModel> {
        try {
            return await this.downtimetrackingService.getAllActiveDownTimeTracking();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllDownTimeTrackingResponseModel, error)
        }
    }
    @Post('/getActiveDownTimeTrackingById')
    async getActiveDownTimeTrackingById(@Body() downtimetrackingreq: DownTimeTrackingRequest): Promise<DownTimeTrackingResponsemodel> {
        try {
            return await this.downtimetrackingService.getActiveDownTimeTrackingById(downtimetrackingreq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(DownTimeTrackingResponsemodel, err);
        }
    }

   @Post('/gettrackingGroupbyReason')
   async gettrackingGroupbyReason( @Body() req:DownTimeTrackingPiechartRequest): Promise<DowntimePiechartResonseModel>{
    try{
      return await this.downtimetrackingService.gettrackingGroupbyReason(req);
    }catch(err){
      return this.applicationExceptionHandler.returnException(DowntimePiechartResonseModel,err);
    }
   }
   
   @Post('/gettrackingDepartmentData')
   async gettrackingDepartmentData(): Promise<AllDownTimeTrackingResponseModel>{
    try{
      return await this.downtimetrackingService.gettrackingDepartmentData();
    }catch(err){
      return this.applicationExceptionHandler.returnException(AllDownTimeTrackingResponseModel,err);
    }
   }

   @Post('/getTotalDowntimeDepartmentWise')
   async getTotalDowntimeDepartmentWise(): Promise<AllDownTimeTrackingResponseModel>{
    try{
      return await this.downtimetrackingService.getTotalDowntimeDepartmentWise();
    }catch(err){
      return this.applicationExceptionHandler.returnException(AllDownTimeTrackingResponseModel,err);
    }
   }
@Post('/getTotalDownTimeType')
async getTotalDownTimeType(): Promise<AllDownTimeTrackingResponseModel>{
try {
  return await this.downtimetrackingService.getTotalDownTimeType(); 
} catch (error) {
  return this.applicationExceptionHandler.returnException(AllDownTimeTrackingResponseModel,error)
}}

@Post('/getTotalSkippedSlaAndUndeSla')
async getTotalSkippedSlaAndUndeSla(): Promise<AllDownTimeTrackingResponseModel>{
try {
  return await this.downtimetrackingService.getTotalSkippedSlaAndUndeSla();
  
} catch (error) {
  return this.applicationExceptionHandler.returnException(AllDownTimeTrackingResponseModel,error)
}}

@Post('/getDownTimeTrackingReport')
// @UseGuards(AuthGuard('jwt'))
async getDownTimeTrackingReport(): Promise<AllDownTimeTrackingResponseModel> {
  try {
    return await this.downtimetrackingService.getDownTimeTrackingReport();
  } catch (error) {
    return this.applicationExceptionHandler.returnException(AllDownTimeTrackingResponseModel, error);
  }
}


@Post('/getMachineName')
async getMachineName(@Body() request: DowntimeMachineNameRequest): Promise<CommonResponse> {
    try {
        return await this.downtimetrackingService.getMachineName(request);
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
}
@Post('/alertMessageforSkipedSlaMachine')
async alertMessageforSkipedSlaMachine(): Promise<CommonResponse> {
    try {
        return await this.downtimetrackingService.alertMessageforSkipedSlaMachine();
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error)
    }
}
  @Post('/downtimeventcalnder')
  async downtimeventcalnder(): Promise<CommonResponse> {
      try {
          return await this.downtimetrackingService.downtimeventcalnder();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error)
      }
  }
  @Post('/assetCategoryDropDown')
  async assetCategoryDropDown(): Promise<CommonResponse> {
      try {
          return await this.downtimetrackingService.assetCategoryDropDown();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error)
      }
  }
 }